var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redeem-flow"},[(_vm.isAuthenticating)?_c('parameter-router-auth-container',{attrs:{"initialAuthType":"signup","id":"redeem-authentication"}}):_c('redeem-integration')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }